import { PropsWithChildren } from 'react';

import {
  InternalLinkInterceptor,
  InternalLinkInterceptorContext,
} from './internalLinkInterceptor.context';

/**
 * Mounts an interceptor over the internal links rendered beneath it, letting
 * the host surface handle the targets it claims in place of the default route
 * navigation. E.g. ChatSideContentLinkInterceptor claims document-summary
 * links and opens them in the chat side content pane.
 *
 * Pass a referentially stable interceptor (useCallback): every InternalLink
 * below re-resolves its click behavior when the interceptor changes.
 */
export function InternalLinkInterceptorProvider({
  interceptor,
  children,
}: PropsWithChildren<{ interceptor: InternalLinkInterceptor }>) {
  return (
    <InternalLinkInterceptorContext.Provider value={interceptor}>
      {children}
    </InternalLinkInterceptorContext.Provider>
  );
}
